import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Tooltip } from "primereact/tooltip";

import { useAppSelector } from "store/store";
import { getSuggestionClassNameByIndex } from "utils";
export const SuggestionCard = ({
  icon,
  name,
  callback,
  isActive,
  index,
}: {
  icon: any;
  name: string;
  callback: () => void;
  isActive: boolean;
  index: number;
}) => {
  const count = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.count
  );

  const waitMessage = useAppSelector(
    (state) => state.gestioneChatSlice.waitMessage
  );

  const newMessage = useAppSelector(
    (state) => state.gestioneChatSlice.newMessage
  );

  return (
    <>
      <Tooltip
        target={`.container-suggestion-card`}
        mouseTrack
        mouseTrackLeft={10}
      />
      <Button
        className={`container-suggestion-card flex-container align-center padd-8 gap-8 ${
          !count ? "disabled" : ""
        } ${
          isActive && count
            ? "active-suggestion-card "
            : "deactive-suggestion-card"
        } ${getSuggestionClassNameByIndex(index)}`}
        onClick={callback}
        disabled={!count || waitMessage || newMessage}
        type="button"
        data-pr-tooltip={name}
      >
        <div className="icon-suggestion-card">
          <Image src={icon} />
        </div>
        <div className="text-title">{name}</div>
      </Button>
    </>
  );
};
